import "./LoaderDebugChatbox.css";
import { useConversationStateContext } from "../../../context/ConversationContext";

const LoaderDebugChatbox = () => {

    var { isLoadingResponse } = useConversationStateContext();

    return (
        <div id="kwalys-loader-debug">
           { isLoadingResponse == true && <span className="loader-debug"></span>}
           { isLoadingResponse == "error" && <span className="loader-debug-error"><i className="fas fa-times" style={{color : "#f0386b"}}></i></span>}
        </div>
    );
};

export default LoaderDebugChatbox;
